export const NodeTypeEnum = {
  LORAWAN: 0,
  API: 1,
  MQTT: 2,
  NODERED: 3,
  SPARKPLUG: 4,
  SPOTIO: 5,
  MODBUS: 6,
  OPC: 7,
};

export function nodeTypeToString(nodeType: number): string {
  switch (nodeType) {
    case NodeTypeEnum.LORAWAN:
      return "LoRaWAN";
    case NodeTypeEnum.API:
      return "API";
    case NodeTypeEnum.MQTT:
      return "MQTT";
    case NodeTypeEnum.NODERED:
      return "Node-RED";
    case NodeTypeEnum.SPARKPLUG:
      return "Sparkplug";
    case NodeTypeEnum.SPOTIO:
      return "SpotIO";
    case NodeTypeEnum.MODBUS:
      return "Modbus";
    case NodeTypeEnum.OPC:
      return "OPC";
    default:
      return "Unknown";
  }
}

export const NodeTypeOptions = [
  { value: NodeTypeEnum.LORAWAN, label: "LoRaWAN" },
  { value: NodeTypeEnum.API, label: "API" },
  { value: NodeTypeEnum.MQTT, label: "MQTT" },
  { value: NodeTypeEnum.NODERED, label: "Node-RED" },
  { value: NodeTypeEnum.SPARKPLUG, label: "Sparkplug" },
  { value: NodeTypeEnum.SPOTIO, label: "SpotIO" },
  { value: NodeTypeEnum.MODBUS, label: "Modbus" },
  { value: NodeTypeEnum.OPC, label: "OPC" },
];

export type CompanySettings = {
  WHITE_LABEL_IMAGE?: string;
  NODE_ALIAS?: string;
  ALARM_TITLE?: string;
  SMS_IP1_PASSWORD?: string;
  SMS_IP1_USERNAME?: string;
  SMS_PROVIDER?: string;
  SMS_TWILIO_NUMBER?: string;
  SMS_IP1_FROM?: string;
  NODE_TITLE?: string;
  SMS_TWILIO_ACCOUNTSID?: string;
  COORDINATES?: string;
  INACTIVITY_ALARM_CONTACT?: string;
  NODE_TABLE_COLUMNS?: string;
  SMS_TWILIO_ACCESSTOKEN?: string;
  MAPSETTINGS?: string;
  COMPANY_BRANDING_TITLE?: string;
};

export type NodeTableColumnSettings = {
  index: number;
  title?: string;
  key: string;
  subgroup?: string;
  isDefault: boolean;
  isAttribute: boolean;
  useLangLine: boolean;
  langLine?: string | null;
  sortable?: boolean | null;
};

export const DataSourceTypeMap = {
  0: "API",
  1: "MQTT",
  2: "Sparkplug",
  3: "Script",
  4: "Integration",
  5: "Nordpool",
  6: "SpotIO",
  7: "Modbus",
  8: "OPC",
  9: "Formula",
};

export function getDataSourceTypeName(type: number): string {
  return DataSourceTypeMap[type as keyof typeof DataSourceTypeMap] || "Unknown";
}
